// JSHint ignores
/* global FastClick: true */
(function ($) {
    $(document).ready(function () {
        prepare_fitvid();
        prepare_menu({
            container: $('#content'),
            menu_button: $('.menu-button'),
            menu_active_class: 'menu-active'
        });
        prepare_indicator();
        prepare_slider();
        prepare_tabs();
    });

    function prepare_fitvid() {
        $("#page").fitVids();
    }

    function prepare_menu(options) {
        options.menu_button.on('click', function (e) {
            var body = $('body');

            body.toggleClass(options.menu_active_class);

            // if the menu is displayed, hook up an event to hide the menu when #page is tapped but not scrolled
            if (body.hasClass(options.menu_active_class)) {
                options.container.on('click', function () {
                    body.toggleClass(options.menu_active_class);
                    options.container.off('click'); // don't need to listen to this until the menu is opened
                });
                return;
            }

            options.container.off('click'); // don't need to listen to this until the menu is opened
        });

        $('.sub-menu').collapse({toggle: false}).addClass('collapse');

        $('.btn-menu-dropdown').on('click', function (e) {
            $(this).siblings('.sub-menu').collapse('toggle');
        });
    }
    function prepare_indicator() {
        var elems = document.getElementsByClassName('wp-block-rallyday-blocks-anchor');
        if (!elems.length) {
            return;
        }
        var animateHTML = function () {
            var windowHeight,
            circles
            var init = function () {
                $('#page-indicator').removeClass('hidden');
                circles = $('#page-indicator').find('circle');
                windowHeight = window.innerHeight;
                _addEventHandlers();
            }
            var _addEventHandlers = function () {
                window.addEventListener('scroll', _checkPosition);
                window.addEventListener('resize', init);
            }
            var _checkPosition = function () {
                for (var i = 0; i < elems.length; i++) {
                var posFromTop = elems[i].getBoundingClientRect().top;
                    if (posFromTop - windowHeight <= 0) {
                        $(circles).css('fill', '');
                        $(circles[i]).css('fill', '#CF9D00');
                    }
                }
            }
            return {
                init: init
            }
        }
    animateHTML().init()
    }
    function prepare_slider() {
        $('.slick').slick({
            dots: true,
            slidesToShow: 1,
            infinite: true,
            arrows: true,
            autoPlay: true
        });
    }
    function prepare_tabs() {
        /* eslint-disable */

        function ub_getSiblings(element, criteria) {
            const children = [...element.parentNode.children].filter(
                child => child !== element
            );
            return criteria ? children.filter(criteria) : children;
        }

        function ub_getNodeindex(elm) {
            return [...elm.parentNode.children].indexOf(elm);
        }

        Array.from(
            document.getElementsByClassName('wp-block-ub-tabbed-content-tab-title-wrap')
        ).forEach(instance => {
            instance.addEventListener('click', function() {
                const parent = instance.closest('.wp-block-ub-tabbed-content');
                const contentWrapEl = [
                    ...parent.querySelectorAll(
                        '.wp-block-ub-tabbed-content-tab-content-wrap'
                    )
                ];
                const activeStyle = parent
                    .querySelector('.wp-block-ub-tabbed-content-tab-title-wrap.active');
                const defaultStyle = parent
                    .querySelector(
                        '.wp-block-ub-tabbed-content-tab-title-wrap:not(.active)'
                    );

                ub_getSiblings(instance, elem =>
                    elem.classList.contains('wp-block-ub-tabbed-content-tab-title-wrap')
                ).forEach(sibling => {
                    sibling.classList.remove('active');
                });

                instance.classList.add('active');

                contentWrapEl.forEach(tabContent => {
                    tabContent.classList.remove('active');
                    tabContent.classList.add('ub-hide');
                });

                const activeTab = parent.querySelector(
                    `.wp-block-ub-tabbed-content-tab-content-wrap:nth-of-type(${ub_getNodeindex(
                        this
                    ) + 1})`
                );

                activeTab.classList.add('active');
                activeTab.classList.remove('ub-hide');
            });
        });

    }

}) (jQuery);



// WEBPACK FOOTER //
// ./res/js/global.js